/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/doctype-selector.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../src/app/search-panel/services/search-api.service';
import * as import10 from '../../../../../src/app/search-panel/services/search-config.service';
import * as import11 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import12 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from '@angular/core/src/linker/element_ref';
import * as import15 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import16 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import17 from '../../../../../src/app/shared/components/status.component';
import * as import18 from '../../shared/components/status.component.ngfactory';
import * as import19 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import20 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import21 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from 'ng2-translate/src/translate.pipe';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import25 from 'ng2-translate/src/translate.service';
import * as import26 from '@angular/common/src/directives/ng_for';
import * as import27 from '@angular/forms/src/directives/control_value_accessor';
import * as import28 from '@angular/forms/src/directives/ng_model';
import * as import29 from '@angular/forms/src/directives/ng_control';
import * as import30 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_DocTypeSelectorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DocTypeSelectorComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.DocTypeSelectorComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_selection(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.selection = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.selectionChange.subscribe(_eventHandler.bind(view,'selectionChange'))); }
  }
}
var renderType_DocTypeSelectorComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DocTypeSelectorComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DocTypeSelectorComponent>;
  _DocTypeSelectorComponent_0_3:Wrapper_DocTypeSelectorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocTypeSelectorComponent_Host0,renderType_DocTypeSelectorComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-doctype-selector',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DocTypeSelectorComponent0(this.viewUtils,this,0,this._el_0);
    this._DocTypeSelectorComponent_0_3 = new Wrapper_DocTypeSelectorComponent(this.injectorGet(import9.SearchApiService,this.parentIndex),this.injectorGet(import10.SearchConfigService,this.parentIndex));
    this.compView_0.create(this._DocTypeSelectorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DocTypeSelectorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DocTypeSelectorComponent) && (0 === requestNodeIndex))) { return this._DocTypeSelectorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DocTypeSelectorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._DocTypeSelectorComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DocTypeSelectorComponentNgFactory:import8.ComponentFactory<import0.DocTypeSelectorComponent> = new import8.ComponentFactory<import0.DocTypeSelectorComponent>('obpa-doctype-selector',View_DocTypeSelectorComponent_Host0,import0.DocTypeSelectorComponent);
const styles_DocTypeSelectorComponent:any[] = ([] as any[]);
class View_DocTypeSelectorComponent1 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import11.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import12.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_DocTypeSelectorComponent1,renderType_DocTypeSelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import11.Wrapper_NgSelectOption(new import14.ElementRef(this._el_0),this.renderer,(<View_DocTypeSelectorComponent0>this.parentView)._SelectControlValueAccessor_7_3.context);
    this._NgSelectMultipleOption_0_4 = new import12.Wrapper_NgSelectMultipleOption(new import14.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import16.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_DocTypeSelectorComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_DocTypeSelectorComponent,{});
export class View_DocTypeSelectorComponent0 extends import2.AppView<import0.DocTypeSelectorComponent> {
  _el_0:any;
  compView_0:import2.AppView<import17.StatusComponent>;
  _StatusComponent_0_3:import18.Wrapper_StatusComponent;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _SelectControlValueAccessor_7_3:import11.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_7_4:any[];
  _NgModel_7_5:import19.Wrapper_NgModel;
  _NgControl_7_6:any;
  _NgControlStatus_7_7:import20.Wrapper_NgControlStatus;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import13.ViewContainer;
  _TemplateRef_9_5:any;
  _NgFor_9_6:import21.Wrapper_NgFor;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _pipe_translate_0:import22.TranslatePipe;
  /*private*/ _expr_25:any;
  _pipe_translate_1:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocTypeSelectorComponent0,renderType_DocTypeSelectorComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_25 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'obpa-status',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import18.View_StatusComponent0(this.viewUtils,this,0,this._el_0);
    this._StatusComponent_0_3 = new import18.Wrapper_StatusComponent();
    this._text_1 = this.renderer.createText((null as any),'\n    \n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'label',new import3.InlineArray2(2,'for','obpa_doctype'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'select',new import3.InlineArray4(4,'class','form-control','id','obpa_doctype'),(null as any));
    this._SelectControlValueAccessor_7_3 = new import11.Wrapper_SelectControlValueAccessor(this.renderer,new import14.ElementRef(this._el_7));
    this._NG_VALUE_ACCESSOR_7_4 = [this._SelectControlValueAccessor_7_3.context];
    this._NgModel_7_5 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_7_4);
    this._NgControl_7_6 = this._NgModel_7_5.context;
    this._NgControlStatus_7_7 = new import20.Wrapper_NgControlStatus(this._NgControl_7_6);
    this._text_8 = this.renderer.createText(this._el_7,'\n            ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_7,(null as any));
    this._vc_9 = new import13.ViewContainer(9,7,this,this._anchor_9);
    this._TemplateRef_9_5 = new import23.TemplateRef_(this,9,this._anchor_9);
    this._NgFor_9_6 = new import21.Wrapper_NgFor(this._vc_9.vcRef,this._TemplateRef_9_5,this.parentView.injectorGet(import24.IterableDiffers,this.parentIndex),this.ref);
    this._text_10 = this.renderer.createText(this._el_7,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_12 = this.renderer.createText((null as any),'\n    \n',(null as any));
    this.compView_0.create(this._StatusComponent_0_3.context);
    this._text_13 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'retry',(null as any)),this.eventHandler(this.handleEvent_0));
    this._StatusComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_7,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_7));
    this._NgModel_7_5.subscribe(this,this.eventHandler(this.handleEvent_7),true);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import26.NgFor) && (9 === requestNodeIndex))) { return this._NgFor_9_6.context; }
    if (((token === import15.SelectControlValueAccessor) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._SelectControlValueAccessor_7_3.context; }
    if (((token === import27.NG_VALUE_ACCESSOR) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NG_VALUE_ACCESSOR_7_4; }
    if (((token === import28.NgModel) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgModel_7_5.context; }
    if (((token === import29.NgControl) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgControl_7_6; }
    if (((token === import30.NgControlStatus) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgControlStatus_7_7.context; }
    if (((token === import17.StatusComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._StatusComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.status;
    this._StatusComponent_0_3.check_status(currVal_0_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_0_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('ERROR: DOCTYPES')),'');
    this._StatusComponent_0_3.check_error(currVal_0_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    this._StatusComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._SelectControlValueAccessor_7_3.ngDoCheck(this,this._el_7,throwOnChange);
    const currVal_7_1_0:any = this.context.selection;
    this._NgModel_7_5.check_model(currVal_7_1_0,throwOnChange,false);
    this._NgModel_7_5.ngDoCheck(this,this._el_7,throwOnChange);
    this._NgControlStatus_7_7.ngDoCheck(this,this._el_7,throwOnChange);
    const currVal_9_0_0:any = this.context.doctypes;
    this._NgFor_9_6.check_ngForOf(currVal_9_0_0,throwOnChange,false);
    this._NgFor_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('DOCUMENT TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_5,currVal_25);
      this._expr_25 = currVal_25;
    }
    this._NgControlStatus_7_7.checkHost(this,this,this._el_7,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_9.destroyNestedViews();
    this.compView_0.destroy();
    this._NgModel_7_5.ngOnDestroy();
    this._StatusComponent_0_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 0) && (ngContentIndex == 0))) {
      cb(this._text_1,ctx);
      cb(this._el_2,ctx);
      cb(this._text_12,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 9)) { return new View_DocTypeSelectorComponent1(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'retry')) {
      const pd_sub_0:any = ((<any>this.context.onRetry()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_7(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_7_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>this.context.onSelectionChange($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/doctype-selector.component.ngfactory.ts